var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// openmosh-definitions.ts
var openmosh_definitions_exports = {};
__export(openmosh_definitions_exports, {
  ASCII_CHARSETS: () => ASCII_CHARSETS,
  EFFECT_DEFINITIONS: () => EFFECT_DEFINITIONS
});
module.exports = __toCommonJS(openmosh_definitions_exports);
var ASCII_CHARSETS = [
  { label: "Classic", value: "classic", chars: " .-:;i+r*oX#%&$@" },
  { label: "Blocks", value: "blocks", chars: " .\xB7:\u2591\u2591\u2591\u2592\u2592\u2593\u2593\u2588\u2588\u2588\u2588" },
  { label: "Binary", value: "binary", chars: "        00001111" },
  { label: "Numbers", value: "numbers", chars: " .-:;17245308#%@" }
];
var EFFECT_DEFINITIONS = [
  {
    id: "pixelate",
    name: "Pixelate",
    params: [
      {
        key: "size",
        label: "Size",
        type: "range",
        min: 1,
        max: 100,
        step: 1,
        defaultValue: 10
      }
    ]
  },
  {
    id: "posterize",
    name: "Posterize",
    params: [
      {
        key: "levels",
        label: "Levels",
        type: "range",
        min: 2,
        max: 20,
        step: 1,
        defaultValue: 8
      }
    ]
  },
  {
    id: "solarize",
    name: "Solarize",
    params: [
      {
        key: "threshold",
        label: "Threshold",
        type: "range",
        min: 0,
        max: 0.9,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "edges",
    name: "Edges",
    params: [
      {
        key: "strength",
        label: "Strength",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "mix",
        label: "Mix",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      }
    ]
  },
  {
    id: "neon-edges",
    name: "Neon Edges",
    params: [
      {
        key: "strength",
        label: "Strength",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1.5
      },
      {
        key: "glow",
        label: "Glow",
        type: "range",
        min: 0,
        max: 3,
        step: 0.05,
        defaultValue: 1
      },
      {
        key: "bg",
        label: "Background",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.05
      }
    ]
  },
  {
    id: "bleach",
    name: "Bleach",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "sharpen",
    name: "Sharpen",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 10,
        step: 0.01,
        defaultValue: 3
      },
      {
        key: "radius",
        label: "Radius",
        type: "range",
        min: 0.5,
        max: 25,
        step: 0.5,
        defaultValue: 5
      },
      {
        key: "threshold",
        label: "Threshold",
        type: "range",
        min: 0,
        max: 0.25,
        step: 5e-3,
        defaultValue: 0
      }
    ]
  },
  {
    id: "mirror",
    name: "Mirror",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "side",
        label: "Side",
        type: "range",
        min: 0,
        max: 3,
        step: 1,
        defaultValue: 0
      },
      {
        key: "position",
        label: "Position",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "kaleido",
    name: "Kaleido",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "sides",
        label: "Sides",
        type: "range",
        min: 2,
        max: 12,
        step: 1,
        defaultValue: 6
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      }
    ]
  },
  {
    id: "channel-split",
    name: "Channel Split",
    params: [
      {
        key: "mode",
        label: "Mode",
        type: "select",
        defaultValue: "linear",
        options: [
          { label: "Linear", value: "linear" },
          { label: "Radial", value: "radial" },
          { label: "Prismatic", value: "prismatic" }
        ]
      },
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 50,
        step: 0.1,
        defaultValue: 10
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0,
        visibleWhen: (v) => v.mode === "linear" || v.mode === "prismatic"
      },
      {
        key: "falloff",
        label: "Falloff",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5,
        visibleWhen: (v) => v.mode === "radial"
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0,
        max: 5,
        step: 0.1,
        defaultValue: 1,
        visibleWhen: (v) => v.mode === "prismatic"
      },
      {
        key: "saturation",
        label: "Hue Shift",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5,
        visibleWhen: (v) => v.mode === "prismatic"
      }
    ]
  },
  {
    id: "color-correction",
    name: "Color Correction",
    params: [
      {
        key: "brightness",
        label: "Brightness",
        type: "range",
        min: -1,
        max: 1,
        step: 0.01,
        defaultValue: 0,
        moshMin: -0.5
      },
      {
        key: "contrast",
        label: "Contrast",
        type: "range",
        min: -1,
        max: 1,
        step: 0.01,
        moshMin: -0.5,
        moshMax: 0.5,
        defaultValue: 0
      },
      {
        key: "hue",
        label: "Hue",
        type: "range",
        min: -180,
        max: 180,
        step: 1,
        defaultValue: 0
      },
      {
        key: "saturation",
        label: "Saturation",
        type: "range",
        min: -1,
        max: 1,
        step: 0.01,
        defaultValue: 0
      }
    ]
  },
  {
    id: "vignette",
    name: "Vignette",
    params: [
      {
        key: "size",
        label: "Size",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "scanlines",
    name: "Scanlines",
    params: [
      {
        key: "count",
        label: "Count",
        type: "range",
        min: 1,
        max: 500,
        step: 1,
        defaultValue: 100
      },
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "bulge",
    name: "Bulge",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: -1,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "radius",
        label: "Radius",
        type: "range",
        min: 0.01,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "jitter",
    name: "Jitter",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 100,
        step: 1,
        defaultValue: 20
      },
      {
        key: "seed",
        label: "Seed",
        type: "range",
        min: 0,
        max: 1e3,
        step: 1,
        defaultValue: 0
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1
      }
    ]
  },
  {
    id: "wobble",
    name: "Wobble",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 100,
        step: 1,
        defaultValue: 20
      },
      {
        key: "frequency",
        label: "Frequency",
        type: "range",
        min: 1,
        max: 5,
        step: 0.1,
        defaultValue: 3
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1
      }
    ]
  },
  {
    id: "slices",
    name: "Slices",
    params: [
      {
        key: "count",
        label: "Count",
        type: "range",
        min: 1,
        max: 50,
        step: 1,
        defaultValue: 10
      },
      {
        key: "offset",
        label: "Offset",
        type: "range",
        min: 0,
        max: 100,
        step: 1,
        defaultValue: 20
      },
      {
        key: "direction",
        label: "Direction",
        type: "select",
        defaultValue: "horizontal",
        options: [
          { label: "Horizontal", value: "horizontal" },
          { label: "Vertical", value: "vertical" }
        ]
      }
    ]
  },
  {
    id: "shake",
    name: "Shake",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 50,
        step: 1,
        defaultValue: 10
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 1,
        max: 60,
        step: 1,
        defaultValue: 20,
        curve: 5
      }
    ]
  },
  {
    id: "glow",
    name: "Glow",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 50,
        step: 0.01,
        defaultValue: 4
      },
      {
        key: "cutoff",
        label: "Cutoff",
        type: "range",
        min: 0,
        max: 0.7,
        step: 0.01,
        defaultValue: 0.3
      },
      {
        key: "radius",
        label: "Radius",
        type: "range",
        min: 1,
        max: 10,
        step: 0.5,
        defaultValue: 8
      }
    ]
  },
  {
    id: "soft-glitch",
    name: "Glitch",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 50,
        step: 1,
        defaultValue: 15
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 2
      }
    ]
  },
  {
    id: "optical-flow",
    name: "Optical Flow",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.65
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 10,
        step: 0.1,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "vhs",
    name: "VHS",
    params: [
      {
        key: "static",
        label: "Static",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1
      },
      {
        key: "tracking",
        label: "Tracking",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "duotone",
    name: "Duotone",
    params: [
      {
        key: "shadowHue",
        label: "Shadow Hue",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 220
      },
      {
        key: "highlightHue",
        label: "Highlight Hue",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 40
      },
      {
        key: "intensity",
        label: "Intensity",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      }
    ]
  },
  {
    id: "grain",
    name: "Grain",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.3
      },
      { key: "rgb", label: "RGB", type: "checkbox", defaultValue: 1 },
      {
        key: "blendMode",
        label: "Blend Mode",
        type: "select",
        defaultValue: "additive",
        options: [
          { label: "Additive", value: "additive" },
          { label: "Softlight", value: "softlight" },
          { label: "Multiply", value: "multiply" }
        ]
      }
    ]
  },
  {
    id: "polar",
    name: "Polar",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      }
    ]
  },
  {
    id: "tile",
    name: "Tile",
    params: [
      {
        key: "size",
        label: "Size",
        type: "range",
        min: 1,
        max: 10,
        step: 0.1,
        defaultValue: 2
      },
      {
        key: "offset",
        label: "Offset",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0,
        max: 50,
        step: 0.1,
        defaultValue: 0,
        moshMax: 20
      }
    ]
  },
  {
    id: "data-bend",
    name: "Data Bend",
    params: [
      {
        key: "intensity",
        label: "Intensity",
        type: "range",
        min: 0,
        max: 100,
        step: 1,
        defaultValue: 30
      },
      {
        key: "corruption",
        label: "Corruption",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.3
      },
      {
        key: "channelShift",
        label: "Channel Shift",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.2
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.5,
        max: 20,
        step: 0.5,
        defaultValue: 4
      }
    ]
  },
  {
    id: "melt",
    name: "Melt",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1
      }
    ]
  },
  {
    id: "emboss",
    name: "Emboss",
    params: [
      {
        key: "strength",
        label: "Strength",
        type: "range",
        min: 0,
        max: 5,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 135
      },
      {
        key: "mix",
        label: "Mix",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "thermal",
    name: "Thermal",
    params: [
      {
        key: "intensity",
        label: "Intensity",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "palette",
        label: "Palette",
        type: "select",
        defaultValue: "thermal",
        options: [
          { label: "Thermal", value: "thermal" },
          { label: "Infrared", value: "infrared" },
          { label: "Night Vision", value: "night-vision" }
        ]
      }
    ]
  },
  {
    id: "color-halves",
    name: "Color Halves",
    params: [
      {
        key: "position",
        label: "Position",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      },
      {
        key: "mode",
        label: "Mode",
        type: "select",
        defaultValue: "invert",
        options: [
          { label: "Invert", value: "invert" },
          { label: "Hue Shift", value: "hue-shift" },
          { label: "Desaturate", value: "desaturate" },
          { label: "High Contrast", value: "high-contrast" }
        ]
      },
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      }
    ]
  },
  {
    id: "stereoscopic",
    name: "Stereoscopic",
    params: [
      {
        key: "depth",
        label: "Depth",
        type: "range",
        min: 0,
        max: 50,
        step: 1,
        defaultValue: 10
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      },
      {
        key: "mode",
        label: "Mode",
        type: "select",
        defaultValue: "anaglyph",
        options: [
          { label: "Anaglyph", value: "anaglyph" },
          { label: "Color Split", value: "color-split" }
        ]
      },
      {
        key: "depthSource",
        label: "Depth Source",
        type: "select",
        defaultValue: "luminance",
        options: [
          { label: "Luminance", value: "luminance" },
          { label: "Edges", value: "edges" },
          { label: "Flat", value: "flat" }
        ]
      },
      {
        key: "focus",
        label: "Focus",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "pixel-sort",
    name: "Pixel Sort",
    params: [
      {
        key: "threshold",
        label: "Threshold",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "ceiling",
        label: "Ceiling",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1
      },
      {
        key: "range",
        label: "Range",
        type: "range",
        min: 0,
        max: 200,
        step: 1,
        defaultValue: 80
      },
      {
        key: "direction",
        label: "Direction",
        type: "select",
        defaultValue: "horizontal",
        options: [
          { label: "Horizontal", value: "horizontal" },
          { label: "Vertical", value: "vertical" }
        ]
      },
      { key: "reverse", label: "Reverse", type: "checkbox", defaultValue: 0 }
    ]
  },
  {
    id: "smear",
    name: "Smear",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 0
      }
    ]
  },
  {
    id: "fiber-displace",
    name: "Fiber Displace",
    params: [
      {
        key: "strength",
        label: "Strength",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.4
      },
      {
        key: "density",
        label: "Stripe Density",
        type: "range",
        min: 2,
        max: 50,
        step: 1,
        defaultValue: 30
      },
      {
        key: "chrome",
        label: "Colorize",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "smoothness",
        label: "Smoothness",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.3
      }
    ]
  },
  {
    id: "relief",
    name: "Relief",
    params: [
      {
        key: "amount",
        label: "Depth",
        type: "range",
        min: 0,
        max: 0.8,
        step: 5e-3,
        defaultValue: 0.35
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 360,
        step: 1,
        defaultValue: 30
      }
    ]
  },
  {
    id: "zoom",
    name: "Zoom",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: -1,
        max: 1,
        step: 0.01,
        defaultValue: 0
      }
    ]
  },
  {
    id: "tunnel",
    name: "Tunnel",
    params: [
      {
        key: "zoom",
        label: "Zoom",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.3
      },
      {
        key: "spin",
        label: "Spin",
        type: "range",
        min: -180,
        max: 180,
        step: 1,
        defaultValue: 0
      },
      {
        key: "decay",
        label: "Decay",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.2
      }
    ]
  },
  {
    id: "halftone",
    name: "Halftone",
    params: [
      {
        key: "scale",
        label: "Scale",
        type: "range",
        min: 2,
        max: 40,
        step: 0.5,
        defaultValue: 8
      },
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 90,
        step: 1,
        defaultValue: 15
      },
      {
        key: "contrast",
        label: "Contrast",
        type: "range",
        min: 0.5,
        max: 2,
        step: 0.05,
        defaultValue: 1
      },
      {
        key: "mode",
        label: "Mode",
        type: "select",
        defaultValue: "dots",
        options: [
          { label: "Dots", value: "dots" },
          { label: "Dither", value: "dither" },
          { label: "Lines", value: "lines" }
        ]
      },
      { key: "invert", label: "Invert", type: "checkbox", defaultValue: 0 }
    ]
  },
  {
    id: "swirl",
    name: "Swirl",
    params: [
      {
        key: "angle",
        label: "Angle",
        type: "range",
        min: 0,
        max: 720,
        step: 1,
        defaultValue: 180
      },
      {
        key: "radius",
        label: "Radius",
        type: "range",
        min: 0.1,
        max: 1.5,
        step: 0.01,
        defaultValue: 0.75
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0,
        max: 5,
        step: 0.1,
        defaultValue: 0.5
      }
    ]
  },
  {
    id: "ripple",
    name: "Ripple",
    params: [
      {
        key: "amount",
        label: "Amount",
        type: "range",
        min: 0,
        max: 100,
        step: 0.5,
        defaultValue: 10
      },
      {
        key: "frequency",
        label: "Frequency",
        type: "range",
        min: 1,
        max: 30,
        step: 0.5,
        defaultValue: 8
      },
      {
        key: "speed",
        label: "Speed",
        type: "range",
        min: 0.1,
        max: 5,
        step: 0.1,
        defaultValue: 1
      }
    ]
  },
  {
    id: "blur",
    name: "Blur",
    params: [
      {
        key: "radius",
        label: "Radius",
        type: "range",
        min: 0,
        max: 20,
        step: 0.5,
        defaultValue: 5
      }
    ]
  },
  {
    id: "ascii",
    name: "ASCII",
    params: [
      {
        key: "size",
        label: "Cell Size",
        type: "range",
        min: 20,
        max: 50,
        step: 1,
        defaultValue: 30
      },
      {
        key: "charset",
        label: "Character Set",
        type: "select",
        defaultValue: "classic",
        options: ASCII_CHARSETS.map(({ label, value }) => ({ label, value }))
      },
      {
        key: "color",
        label: "Color",
        type: "select",
        defaultValue: "color",
        options: [
          { label: "Color", value: "color" },
          { label: "Green", value: "green" },
          { label: "White", value: "white" }
        ]
      }
    ]
  },
  {
    id: "radial-blur",
    name: "Radial Blur",
    params: [
      {
        key: "strength",
        label: "Strength",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.4
      }
    ]
  },
  {
    id: "tracking",
    name: "Tracking",
    params: [
      {
        key: "count",
        label: "Targets",
        type: "range",
        min: 1,
        max: 12,
        step: 1,
        defaultValue: 5,
        moshMax: 8
      },
      {
        key: "sensitivity",
        label: "Sensitivity",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5
      },
      {
        key: "size",
        label: "Box Size",
        type: "range",
        min: 0.03,
        max: 0.3,
        step: 5e-3,
        defaultValue: 0.12
      },
      {
        key: "thickness",
        label: "Line Width",
        type: "range",
        min: 1,
        max: 3,
        step: 0.5,
        defaultValue: 2
      },
      {
        key: "opacity",
        label: "Opacity",
        type: "range",
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 1,
        moshMin: 0.6
      },
      {
        key: "color",
        label: "Color",
        type: "select",
        defaultValue: "white",
        options: [
          { label: "White", value: "white" },
          { label: "Black", value: "black" }
        ]
      }
    ]
  }
];
